<template>
    <div class="w-full">
        <PageHeader type="Artist" :title="artist.name" :image="artist.image" round>
            <template #meta>
                {{ artist.songs.length }} {{ artist.songs.length === 1 ? 'song' : 'songs' }}
                <template v-if="artist.albums.length"><span class="mx-1">·</span>{{ artist.albums.length }} {{ artist.albums.length === 1 ? 'album' : 'albums' }}</template>
            </template>
            <template #actions v-if="artist.songs.length">
                <button type="button" class="nl-play-fab h-14 w-14 text-xl" @click="playTop" aria-label="Play">
                    <span class="icon-play translate-x-0.5"></span>
                </button>
            </template>
        </PageHeader>

        <section v-if="artist.songs.length">
            <h2 class="nl-section-title mb-3 px-0.5">Popular</h2>
            <TrackList :songs="showAllSongs ? artist.songs : artist.songs.slice(0, 5)" :ad-after="showAllSongs ? [24] : []" />
            <button v-if="artist.songs.length > 5" type="button" @click="showAllSongs = !showAllSongs"
                class="mt-3 px-3 text-sm font-semibold text-nomad-400 transition-colors hover:text-white">
                {{ showAllSongs ? 'Show less' : 'See all ' + artist.songs.length + ' songs' }}
            </button>
        </section>

        <AdSlot placement="listFeed" class="mt-10" />

        <Shelf title="Albums" :items="artist.albums">
            <template #default="{ item }">
                <MediaCard :href="'/album/' + item.id" :image="item.cover" :title="item.name" :subtitle="item.released_at" />
            </template>
        </Shelf>

        <section v-if="artist.appears.length" class="mt-10">
            <h2 class="nl-section-title mb-3 px-0.5">Appears on</h2>
            <TrackList :songs="artist.appears" />
        </section>

        <Shelf title="Events" :items="artist.events" item-class="w-[55vw] max-w-[14rem] sm:w-52 xl:w-56">
            <template #default="{ item }">
                <div :class="{ 'opacity-50': !item.is_upcoming }">
                    <MediaCard :href="'/event/' + item.id" :image="item.poster" :title="item.name" :subtitle="item.city" poster />
                </div>
            </template>
        </Shelf>

        <section v-if="artist.biography" class="mt-10 max-w-3xl">
            <h2 class="nl-section-title mb-3">About</h2>
            <div class="relative" :class="{ 'max-h-48 overflow-hidden': !expanded }">
                <div v-html="artist.biography" class="nl-prose text-[0.9375rem] text-nomad-300"></div>
                <div v-if="!expanded" class="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-nomad-850"></div>
            </div>
            <button @click="expandBio" type="button" class="mt-3 text-sm font-semibold text-nomad-400 transition-colors hover:text-white">
                {{ expanded ? 'Show less' : 'Read more' }}
            </button>
        </section>
    </div>
</template>



<script setup>
defineProps({ artist: Object });
</script>

<script>
import AdSlot from "@/components/ui/AdSlot.vue";
import CardSong from "@/components/CardSong.vue";
import AlbumCard from "@/components/AlbumCard.vue";
import EventCard from '@/components/EventCard.vue';
import PageHeader from "@/components/ui/PageHeader.vue";
import TrackList from "@/components/ui/TrackList.vue";
import Shelf from "@/components/ui/Shelf.vue";
import MediaCard from "@/components/ui/MediaCard.vue";
import { defineAsyncComponent } from 'vue'
import { usePage } from "@inertiajs/vue3";
const page = usePage();
export default {
    inject: ["current"],
    provide() {
        return {
            stream: this.$root.$data,
        };
    },
    data() {
        return {
            expanded: false,
            showAllSongs: false,
        };
    },
    components: {
        AdSlot,
        PageHeader,
        TrackList,
        Shelf,
        MediaCard,
        CardSong,
        AlbumCard,
        EventCard,
    },
    methods: {
        playTop() {
            const song = this.artist.songs[0];
            this.$store.dispatch('current/prepareCurrent', { id: song.id, type: 'SONG', name: song.name || song.title });
        },
        expandBio() {
            this.expanded = !this.expanded;
        },
    },
    beforeMount() {
        document.title = page.props.title
    }
};
</script>
